import $ from 'jquery';
import { resizeScroll } from '../core/ScrollService.js';
const initSubSection = () => {
    if (document.querySelectorAll('.pSection--sub_section .sub_section')) {
        document.querySelectorAll('.pSection--sub_section .sub_section').forEach((subSection) => {
            subSection.querySelectorAll('.sub_section_content_link').forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    e.preventDefault();
                    let index = elt.getAttribute('data-sub');

                    if (subSection.querySelector('.sub_section_content.active')) {
                        subSection.querySelector('.sub_section_content.active').classList.remove('active');
                    }
                    if (subSection.querySelector('.sub_section_media.active')) {
                        subSection.querySelector('.sub_section_media.active').classList.remove('active');
                    }

                    elt.closest('.sub_section_content').classList.add('active');
                    subSection.querySelector('.sub_section_media[data-sub="' + index + '"]').classList.add('active');
                    resizeScroll();
                })
            });
        });
    }
};

export { initSubSection };
